import React from "react";
import { Link, Navigate, Route, Routes, useNavigate, Redirect } from "react-router-dom";
import logo from "../../assets/logoBioMedika.svg";
import logo2 from "../../assets/new/dashboard.png";
import dropdownIcon from "../../assets/br_down.png";
import read from "../../assets/font-awesome/white/png/128/check-circle.png";
// import CustomComponent from "./component/CustomComponent";
// import plus from "./../images/font-awesome/black/png/32/plus.png";
// import mail from "./../images/font-awesome/black/png/32/envelope-o.png";
// import flag from "./../images/font-awesome/black/png/32/flag-o.png";
// import bell from "./../images/font-awesome/black/png/32/bell-o.png";
// import user from "./../images/font-awesome/black/png/32/user-o.png";
// import user256 from "./../images/font-awesome/black/png/256/user-o.png";
// import doc from "./../images/font-awesome/black/png/32/file-text-o.png";

import cute from "../../assets/cute.mp3";

import messageIcon from "../../assets/messageIcon.svg";
import notificationIcon from "../../assets/notificationIcon.svg";
import ellipse1 from "../../assets/ellipse1.svg";
import vector1 from "../../assets/vector1.svg";

import Dropdown from "react-bootstrap/Dropdown";
import moment from "moment";
import 'moment/locale/id';
import axios from "axios";
import $ from "jquery";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  ButtonGroup,
  Form,
  FormControl,
  Breadcrumb,
  Carousel,
  List,
  Alert,
  Badge,
  Nav,
  NavDropdown,
} from "react-bootstrap";

import Navbar from "react-bootstrap/Navbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, } from '@fortawesome/free-solid-svg-icons';
import { uAPIlocal, misAPI, IP, DEFAULT_FORM } from '../lib/config';
import Cookies from 'js-cookie';
import Swal from "sweetalert2";

let source = axios.CancelToken.source();
axios.defaults.withCredentials = true;
axios.defaults.headers.post["X-CSRF-Token"] = Cookies.get('biomedika-csrf');
axios.defaults.headers.put["X-CSRF-Token"] = Cookies.get('biomedika-csrf');
axios.defaults.headers.delete["X-CSRF-Token"] = Cookies.get('biomedika-csrf');

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      menuLogout: false,
      login: localStorage.getItem("login"),
      detail_login: localStorage.getItem("detail_login"),
      expired: false,
      redirctTo: false,
      statusLogout: 0,
      listNotif: [],
      countNotRead: 0,
      lastCountNotRead: 0,
    };
    this.LogoutClick = this.LogoutClick.bind(this);
    this.HideLogout = this.HideLogout.bind(this);
    this.Logout = this.Logout.bind(this);
    this.readNotif = this.readNotif.bind(this);
  }

  LogoutClick() {
    this.setState({
      menuLogout: !this.state.menuLogout,
    })
  }
  HideLogout() {
    this.setState({
      menuLogout: false,
    });
  }

  // async Logout(ex) {


  //   const formData = new FormData();
  //   const config = {
  //     headers: {
  //       'content-type': 'multipart/form-data'
  //     },
  //     withCredentials: true
  //   };

  //   formData.append('id_user', Cookies.get('biomedika-csrf'));
  //   formData.append('name', localStorage.getItem("name"));
  //   formData.append('message', "Logout");


  //   await axios.post(uAPIlocal + '/api/v1/log', formData, config)
  //     .then(response => {
  //       console.log(response)
  //       if (response.data.status === 406) {
  //         console.log(response);
  //       } else {
  //         localStorage.clear();
  //         setTimeout(() => {
  //           if (ex) {
  //             this.setState({
  //               expired: true
  //             })
  //           } else {
  //             this.setState({
  //               login: false,
  //               detail_login: null,
  //               expired: false
  //             })
  //           }
  //         }, 1000);
  //       }

  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });


  // }

  async Logout(ex) {
    // const formData = new FormData();
    // const config = {
    //   headers: {
    //     'content-type': 'multipart/form-data'
    //   },
    //   withCredentials: true
    // };

    // formData.append('id_user', localStorage.getItem("id_user"));
    // formData.append('name', localStorage.getItem("name"));
    // formData.append('message', "Logout");


    // await axios.post(uAPIlocal + '/api/v1/log', formData, config)
    //   .then(response => {
    //     console.log(response)
    //     if (response.data.status === 406) {
    //       console.log(response)

    //     } else {
    //       console.log(response)
    //     }

    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });

    axios({
      method: "post",
      url: uAPIlocal + "/logout",
    })
      .then((response) => {
        console.log(response);
        Cookies.remove("biomedika-login", { path: '/', domain: '.biomedika.co.id' })
        Cookies.remove("biomedika-csrf", { path: '/', domain: '.biomedika.co.id' })
        Cookies.remove("biomedika-session", { path: '/', domain: '.biomedika.co.id' })
        Cookies.remove("biomedika-userID", { path: '/', domain: '.biomedika.co.id' })
        Cookies.remove("biomedika-level", { path: '/', domain: '.biomedika.co.id' })
        Cookies.remove("biomedika-exp", { path: '/', domain: '.biomedika.co.id' })

        // Cookies.remove("biomedika-login", { path: '/'})
        // Cookies.remove("biomedika-csrf", { path: '/'})
        // Cookies.remove("biomedika-userID", { path: '/'})
        // Cookies.remove("biomedika-level", { path: '/'})
        // Cookies.remove("biomedika-exp", { path: '/'})

        localStorage.clear();
        sessionStorage.clear();

        if (ex == 0) {
          this.setState({ redirctTo: true, statusLogout: 1 });
        } else {
          this.setState({ redirctTo: true, statusLogout: 0 });
        }

        // buat bedain logout dan sesi habis

      })
      .catch((error) => {
        console.log(error);
      });

  }

  async readNotif(id) {

    alert("Tugas diterima")


    let f = new FormData();
    f.append('id', id);

    for (var pair of f.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
    }

    axios({
        method: "put",
        url: uAPIlocal + "/api/v1/read_notification",
        data: f,
        headers: { 'content-type': 'multipart/form-data' }
    })
        .then((response) => {
            console.log("ini res", response);
            // let data = response.data;

           

        })
        .catch((e) => {
            console.error(e);
        });



  }
  

  myalert() {
    alert("testing");
  }

  playAudio = () => {
    new Audio(cute).play();
  }

  swalSuccess = async (msg) => {
    await swalWithBootstrapButtons.fire({
      icon: "success",
      title: msg,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 6000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
  };

  componentDidMount() {
    this.returnDate();
    this.loadNotification();
    // const match = this.props.match.path;
    console.log("login", localStorage.getItem("login"));
    console.log("ref", document.documentElement);
    // this.intervalId = setInterval(this.timer.bind(this), 10000);
    // this.timerID = setInterval(
    //   () => this.tick(),
    //   // 10000
    //   1000
    // );


    // _csrfPart
    // console.log("mydate", moment().format());
    // console.log("test_cookies", Cookies.get('_loginExpired'));
    // console.log("expired???", moment().isAfter(Cookies.get('_loginExpired')));

    // // if (moment().isAfter(Cookies.get('_loginExpired')) == true || Cookies.get('_loginExpired') == undefined) {
    // if (moment().isAfter(Cookies.get('_loginExpired')) == true ) {
    //   this.Logout('ex');
    // }else{
    //   console.log("lanjut")
    // }

    // alert(localStorage.getItem("_interval"));
    if (localStorage.getItem("_interval") == 'false') {
      // alert("kondisi 1")
      this.stopInterval();
    } else {
      // alert("kondisi 2")
      this.playInterval();
    }


    if (Cookies.get('biomedika-login') == undefined) {
      this.Logout(1);
      this.setState({ redirctTo: true });
    }

  }

  playInterval() {
    this.interval = setInterval(() => {
      this.loadNotification();
      this.returnDate();
      this.setState({
        date: new Date()
      });
    }, 30000);
    // this.timerID = setInterval(
    //   () => this.tick(),
    //   1000
    // );
  }

  stopInterval() {
    clearInterval(this.interval);
    // clearInterval(this.timerID);
  }

  tick() {
    this.loadNotification();
    this.returnDate();
    this.setState({
      date: new Date()
    });
  }


  componentWillUnmount() {
    // clearInterval(this.timerID);
    // if (moment().isAfter(Cookies.get('_loginExpired')) == true) {
    //   this.Logout('ex');
    // }
  }


  returnDate() {
    const formData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };


    axios.post(uAPIlocal + '/api/v1/return-date', formData, config)
      .then(response => {
        console.log(response)
        if (response.data.status === 406) {
          console.log(response)

        } else {
          console.log(response)
        }

      })
      .catch(function (error) {
        console.log(error);
      });


  }


  loadNotification() {
    let f = DEFAULT_FORM();
    // f.append("user_id", Cookies.get('biomedika-csrf'));
    // f.append("user_id", 828);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      },
      withCredentials: false
    };

    // axios.post(misAPI + "/admin/klinik/get_notification/", f, config)

    axios({
      method: "post",
      url: uAPIlocal + `/api/v1/notifications/${Cookies.get('biomedika-userID')}`,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then((response) => {
        let data = response.data.results;
        console.log("ini notif", data);
        // console.log("ini count", data['count']);

        //     //$("#notification").html("");
        //     $("#notif_cont_add").html("");
        //     $("#count_unread_add").html("");
        //     $("#count_notification_add").html(data['count']);

        let count = "";
        if (data['count'] > 0) {
          count = "";
          count += '<span style="color: white" className="badge bg-red"> ' + data['count'] + ' Unread</span>'
        }

        // $("#count_unread").append(count);
        // var countAnnouncement = 0;
        // var countDailyreport = 0;
        // var countComplaint = 0;
        // var countGeneralreports = 0;
        // var countMonthlyreports = 0;
        // var countTechreports = 0;
        // var countItreports = 0;
        // var countClockin = 0;
        // var countGeneralhousekeepingreports = 0;

        // var countNotRead = data['noread'];

        var countNotRead = data.filter(function (el) {
          return el.read == 0;
        }).length;

        var messageNotRead = data[0];

        // alert(countNotRead)

        if (this.state.lastCountNotRead != 0 && this.state.lastCountNotRead != countNotRead) {
          this.swalSuccess(messageNotRead.description);
          this.playAudio();
          this.setState({ lastCountNotRead: countNotRead });

        } else if (this.state.lastCountNotRead != 0 && this.state.lastCountNotRead == countNotRead) {
          this.setState({ lastCountNotRead: countNotRead });
        } else {
          this.setState({ lastCountNotRead: countNotRead });
        }



        var listNotif = [];

        $.each(data, function (index, value) {
          console.log("ini index notif", value);
          // if (index !== 'count') {
          if (value['id'] != undefined && value.data['notif_type'] != 'bookinghs') {
            listNotif.push(value);
            // var notif = "";
            // var isread = false;
            // if (value["read"] == "0") {
            //   isread = true;
            // }

            // notif += '<a href="#" style="color:black;' + ((isread) ? "font-weight:bold;font-style: italic;" : "") + '" onclick="viewDetailNotifAdd(this)" data-id="' + value['id'] + '" data-notif="' + value['dailyreports_id'] + '" className="p-3 d-flex border-bottom">'
            // if (value["photo_profile"] != null) {
            //   notif += '  <div className="drop-img cover-image" data-image-src="<?php echo base_url()?>uploads/avatar/' + value["photo_profile"] + '" style="background: url(\'<?php echo base_url()?>uploads/avatar/' + value["photo_profile"] + '\') center center;">'
            // }
            // else
            //   notif += '  <div className="drop-img cover-image" data-image-src="<?php echo base_url()?>assets/biomedika_theme/admin/img/faces/5.jpg">'

            // notif += '    <span className="avatar-status bg-teal"></span>'
            // notif += '  </div>'
            // notif += '  <div className="wd-90p">'
            // notif += '    <div className="d-flex">'
            // notif += '      <h5 className="mb-1 name">' + value["creator_name"] + '</h5>'
            // notif += '      <p className="time mb-0 text-right ml-auto float-right">' + value['time'] + '</p>'
            // notif += '    </div>'
            // notif += '    <p className="mb-0 desc">' + value["description"] + '</p>'
            // notif += '  </div>'
            // notif += '</a>'

            // // $("#notif_cont_add").append(notif);
            // if (value.data != undefined && value.data != null) {
            //   var d = value.data;
            //   // console.log('notif',d.dailyreports_id, d.dailyreport_id, d.complaint_id);
            //   if (d.dailyreports_id != undefined && d.dailyreports_id != null) {
            //     countDailyreport++;
            //   } else if (d.dailyreport_id != undefined && d.dailyreport_id != null) {
            //     countDailyreport++;
            //   } else if (d.complaint_id != undefined && d.complaint_id != null) {
            //     countComplaint++;
            //   } else if (d.generalreports_id != undefined && d.generalreports_id != null) {
            //     countGeneralreports++;
            //   } else if (d.monthlyreports_id != undefined && d.monthlyreports_id != null) {
            //     countMonthlyreports++;
            //   } else if (d.techreports_id != undefined && d.techreports_id != null) {
            //     countTechreports++;
            //   } else if (d.itreports_id != undefined && d.itreports_id != null) {
            //     countItreports++;
            //   } else if (d.id != undefined && d.id != null) {
            //     countAnnouncement++;
            //   }
            //   else if (d.clockin_id != undefined && d.clockin_id != null) {
            //     countClockin++;
            //   }
            //   else if (d.generalhousekeepingreports_id != undefined && d.generalhousekeepingreports_id != null) {
            //     countGeneralhousekeepingreports++;
            //   }
            // }
          }
          // }
        });


        this.setState({ listNotif: listNotif, countNotRead: countNotRead });

        if (data['count'] == "") {
          this.setState({ listNotif: [], countNotRead: 0 });
        }

        //     console.log(countNotRead);
        //     if(countNotRead > 0 && countNotRead!='undefined')
        //     {
        //       $("#count_notification_add").html(countNotRead);
        //       $(".notification-new_add").html(countNotRead+" new My Reports");
        //       $(".main-header-notification>a>span").removeClass('pulse').addClass("pulse-danger");
        //     } else {
        //       countNotRead = 0;
        //       $("#count_notification_add").html(countNotRead);
        //       $(".notification-new_add").html(countNotRead+" new My Reports");
        //       $(".main-header-notification>a>span").removeClass('pulse-danger').addClass("pulse");
        //     }

        //     if(countDailyreport > 0) {
        //       $("#count_unread_add").html('<span style="color: white" className="badge bg-red">' + countDailyreport + '</span>');
        //     } else {
        //       $("#count_unread_add").hide();
        //     }
        //     if(countComplaint > 0) {
        //       // $("#count_unread_complaint").html('<span style="color: white" className="badge bg-red">' + countComplaint + '</span>');
        //       $("#count_unread_complaint").html(countComplaint);
        //     } else {
        //       $("#count_unread_complaint").hide();
        //     }
        //     if(countGeneralreports > 0) {
        //       // $("#count_unread_complaint").html('<span style="color: white" className="badge bg-red">' + countComplaint + '</span>');
        //       $("#count_unread_generalreports").html(countGeneralreports);
        //     } else {
        //       $("#count_unread_generalreports").hide();
        //     }
        //     if(countMonthlyreports > 0) {
        //       // $("#count_unread_complaint").html('<span style="color: white" className="badge bg-red">' + countComplaint + '</span>');
        //       $("#count_unread_monthlyreports").html(countMonthlyreports);
        //     } else {
        //       $("#count_unread_monthlyreports").hide();
        //     }
        //     if(countTechreports > 0) {
        //       // $("#count_unread_complaint").html('<span style="color: white" className="badge bg-red">' + countComplaint + '</span>');
        //       $("#count_unread_techreports").html(countTechreports);
        //     } else {
        //       $("#count_unread_techreports").hide();
        //     }
        //     if(countItreports > 0) {
        //       // $("#count_unread_complaint").html('<span style="color: white" className="badge bg-red">' + countComplaint + '</span>');
        //       $("#count_unread_itreports").html(countItreports);
        //     } else {
        //       $("#count_unread_itreports").hide();
        //     }
        //     if(countAnnouncement > 0) {
        //       // $("#count_unread_complaint").html('<span style="color: white" className="badge bg-red">' + countComplaint + '</span>');
        //       $("#count_unread_announcements").html(countAnnouncement);
        //     } else {
        //       $("#count_unread_announcements").hide();
        //     }
        //   },
        //   error: function(jqXHR, textStatus, errorThrown) {
        //     console.log(jqXHR, textStatus, errorThrown)
        //   }
        // });


      })
      .catch((e) => {
        console.error(e);
      });
  }


  getCurrentURL() {
    return window.location.href
  }

  viewDetailNotif(node) {
    var currentUrl = this.getCurrentURL();
    console.log("ini URL", IP)
    // node = $(node);
    console.log("node", node);
    var idNotif = node.id;
    // // console.log("id notif", idNotif);
    var notif = null;

    for (var i = 0, i2 = this.state.listNotif.length; i < i2; i++) {
      var n = this.state.listNotif[i];
      if (n.id == idNotif) {
        notif = n;
        break;
      }
    }

    for (var i = 0, i2 = this.state.listNotifCuti.length; i < i2; i++) {
      var n = this.state.listNotifCuti[i];
      if (n.id == idNotif) {
        notif = n;
        break;
      }
    }

    for (var i = 0, i2 = this.state.listNotifAnn.length; i < i2; i++) {
      var n = this.state.listNotifAnn[i];
      if (n.id == idNotif) {
        notif = n;
        break;
      }
    }

    /* jika tidak ditemukan di list notif*/
    if (notif == null) {
      console.log('notif tidak ditemukan');
      return;
    }
    /* jika ditemukan di list notif*/
    var nData = null
    if (notif.data != undefined && notif.data != null) {
      var nData = notif.data;
    }
    /* jika notif tidak memiliki atribut data */
    if (nData == null) {
      console.log('nData is null');
      return;
    }
    var url = null;
    var id = null;

    if (nData.dailyreports_id != undefined && nData.dailyreports_id != null) {
      url = "dailyreports";
      id = nData.dailyreports_id;
    } else if (nData.dailyreport_id != undefined && nData.dailyreport_id != null) {
      url = "dailyreports";
      id = nData.dailyreport_id;
    } else if (nData.complaint_id != undefined && nData.complaint_id != null) {
      url = "complaint";
      id = nData.complaint_id;
    } else if (nData.monthlyreports_id != undefined && nData.monthlyreports_id != null) {
      url = "monthlyreports";
      id = nData.monthlyreports_id;
    } else if (nData.techreports_id != undefined && nData.techreports_id != null) {
      url = "techreports";
      id = nData.techreports_id;
    } else if (nData.qcreport_id != undefined && nData.qcreport_id != null) {
      url = "qc";
      id = nData.qcreport_id;
      document.location = IP + '/admin/' + url + '?notifqc=' + id;
      return;
    } else if (nData.itreports_id != undefined && nData.itreports_id != null) {
      url = "itreports";
      id = nData.itreports_id;
    }
    else if (nData.doc_id != undefined && nData.doc_id != null) {
      url = "doc";
      id = nData.doc_id;
    }

    else if (nData.generalreports_id != undefined && nData.generalreports_id != null) {
      url = "generalreports";
      id = nData.generalreports_id;
    }
    else if (nData.generalhousekeepingreports_id != undefined && nData.generalhousekeepingreports_id != null) {
      url = "generalhousekeepingreports";
      id = nData.generalhousekeepingreports_id;
    }
    else if (nData.lot_number != undefined && nData.lot_number != null) {
      url = "qc";
      id = nData.id_lot_number;


      let f = DEFAULT_FORM();
      f.append("user_id", this.state.detail_login.id_user);
      f.append("id", notif.id);
      axios({
        method: "post",
        url: misAPI + "/admin/announcement/update_notification/",
        data: f,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("ini result", response.data);
          document.location = IP + '/admin/' + url;
          return;

        })
        .catch((e) => {
          console.error(e);
        });




    } else if (nData.event_type != undefined && nData.event_type != null) {
      url = "announcement";
      id = nData.id;

      let f = DEFAULT_FORM();
      f.append("user_id", this.state.detail_login.id_user);
      f.append("id", notif.id);
      axios({
        method: "post",
        url: misAPI + "/admin/announcement/update_notification/",
        data: f,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("ini result", response.data);
          // document.location = IP + '/admin/' + url ;
          // return;

        })
        .catch((e) => {
          console.error(e);
        });


    } else if (nData.id_qc_input != undefined && nData.id_qc_input != null) {
      url = "qc";

      if (nData.id_hasil != undefined && nData.id_hasil != null) {
        id = nData.id_hasil;
        node.attr("id-hasil", id)
      }
      else {
        id = nData.id;
        node.attr("id-hasil", id)
      }
      node.attr("id-qc-input", nData.id_qc_input);
      // showQcChart(node);

      //console.log('format data notifikasi tidak dikenal', node.attr("id-hasil"), notif);

      let f = DEFAULT_FORM();
      f.append("user_id", this.state.detail_login.id_user);
      f.append("id", notif.id);
      axios({
        method: "post",
        url: misAPI + "/admin/qc/set_user_read/",
        data: f,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("ini result", response.data);
          // document.location = IP + '/admin/' + url ;
          // return;

        })
        .catch((e) => {
          console.error(e);
        });

      return;

    }
    if (nData.notif_type == 'homeservice') {
      url = "homeservice";
      id = nData.id;
      // stay
      // alert(JSON.stringify(nData))
      document.location = IP + '/admin/' + url + '?notif=' + id + '&date=' + nData.date + '&branch_id=' + nData.branch_id + '&notif_type=' + nData.notif_type;

      let f = DEFAULT_FORM();
      f.append("user_id", this.state.detail_login.id_user);
      f.append("id", notif.id);
      axios({
        method: "post",
        url: misAPI + "/admin/announcement/update_notification/",
        data: f,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("ini result", response.data);

        })
        .catch((e) => {
          console.error(e);
        });

      return;
    }
    else if (nData.notif_type == 'bookinghs') {
      // alert(notif.id);
      // alert(this.state.detail_login.id_user);
      url = "homeservice";
      id = nData.id;
      document.location = IP + '/admin/' + url + '?notif=' + id + '&date=' + nData.date + '&branch_id=' + nData.branch_id + '&notif_type=' + nData.notif_type;

      let f = DEFAULT_FORM();
      f.append("user_id", this.state.detail_login.id_user);
      f.append("id", notif.id);
      axios({
        method: "post",
        url: misAPI + "/admin/announcement/update_notification/",
        data: f,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("ini result", response.data);

        })
        .catch((e) => {
          console.error(e);
        });

      return;
    }
    else if (nData.notif_type == 'petugashs') {
      url = "master_bm";
      id = nData.id;
      document.location = IP + '/admin/' + url + '?notif=' + id + '&date=' + nData.date + '&branch_id=' + nData.branch_id + '&notif_type=' + nData.notif_type;

      let f = DEFAULT_FORM();
      f.append("user_id", this.state.detail_login.id_user);
      f.append("id", notif.id);
      axios({
        method: "post",
        url: misAPI + "/admin/announcement/update_notification/",
        data: f,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          console.log("ini result", response.data);

        })
        .catch((e) => {
          console.error(e);
        });

      return;
    }
    else if (nData.notif_type == 'suhu') {
      url = "suhu";
      id = nData.id;
      //document.location = '<?= base_url() ?>admin/' + url + '?notif=' + id+'&date='+nData.date+'&branch_id='+nData.branch_id;
      $('#suhu-temp').html(nData.body_temperature);
      $('#suhu-nama').html(nData.user_name);
      $('#suhu-foto').html('<img alt="" width="200px" src="https://120.29.156.110' + nData.user_photo + '">');
      $('#modal_suhu_alert').modal("show");
      return;
    }
    /*else if(nData.id_cuti != undefined && nData.id_cuti != null) {
      url = "reqcuti";
      id = nData.id_cuti+'_'+idNotif;
    }
      -- notif cuti dipisah
    */
    else if (nData.notif_type == 'clockin') {
      url = "hr";
      id = nData.clockin_id;
      document.location = IP + '/admin/' + url + '?notifAbsensi=' + id;
      return false;
    }

    else if (nData.notif_type == 'clockin_suhu') {
      url = "clockin";
      id = nData.clockin_id;
      document.location = IP + '/admin/' + url + '?notifSuhu=' + id;
      return false;
    }

    else if (nData.notif_type == 'absensi') {
      url = "dailyreports";
      id = nData.id;
      document.location = IP + '/admin/' + url + '?notif=' + id + '&notif_type=' + nData.notif_type;
      return;
    }

    if (url == null) {
      console.log('format data notifikasi tidak dikenal', nData, notif);
      return;
    }

    if (currentUrl.indexOf(url) >= 0) {
      //   console.log('trigger click', url, id);
      $("#view_" + id).click();
      var tr = $('#view_' + id);
      if (tr.length > 0) {
        // viewData(tr);
      } else {
        // viewData(null, id);
      }
      return;
    }
    console.log('redirect to page', url);
    document.location = IP + '/admin/' + url + '?notif=' + id;

  }


  read_all_notif() {
    let urlSetReadUser = "<?php echo base_url('admin/klinik/read_all_notif') ?>";
    $.ajax({
      url: urlSetReadUser,
      type: "POST",
      dataType: 'json',
      data: {
        //id: notif.id
      },
      success: function (data) {
        this.loadNotification();
        return;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR, textStatus, errorThrown)
      }
    });
  }


  render() {

    // if (Cookies.get("_login") == undefined && this.state.login == undefined && this.state.expired == false) {
    //   return (<Redirect
    //     to={{
    //       pathname: "/",
    //       login_alert: {
    //         msg: "Silahkan Login Terlebih Dahulu!",
    //       },
    //     }} />)
    // } else if (Cookies.get("_login") == undefined && this.state.login == false && this.state.expired == false) {
    //   return (<Redirect
    //     to={{
    //       pathname: "/",
    //       status: "logout",
    //       login_alert: {
    //         msg: "Berhasil Log Out",
    //       },
    //     }} />)
    // } else if (this.state.expired == true) {
    //   return (<Redirect
    //     to={{
    //       pathname: "/",
    //       login_alert: {
    //         msg: "Sesi Berakhir. Silahkan Login Kembali!",
    //       },
    //     }} />)
    // }

    // pake localstorage
    if (this.state.redirctTo && this.state.statusLogout == 1) {
      localStorage.setItem("loginStatus", "logout");
      localStorage.setItem("_type", 1);
      return (<Redirect
        to={{
          pathname: "/",
        }} />)
    } else if (this.state.redirctTo && this.state.statusLogout != 1) {
      localStorage.setItem("loginStatus", "logout");
      localStorage.setItem("_type", 2);
      return (<Redirect
        to={{
          pathname: "/",
        }} />)
    } else { }



    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <a
        href=""
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <span>
          <i className="fa fa-user"></i>
        </span>
      </a>
    ));


    const CustomMenuAdd = React.forwardRef(
      ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
        return (
          <>
            <div
              className="col-12"
              style={{
                background: 'linear-gradient(45deg, rgba(56, 88, 249, 0.9), rgba(142, 121, 253, 0.9))'
              }}
            >
            </div>
            <div className="col-12">{children}</div>
          </>
        );
      }
    );



    return (
      <>
        <Navbar>
          <Container fluid>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav1">
              <Nav className="me-auto">
                <Nav.Link href="#" >
                  <div id="rectangle-36-new-btn">
                    <span>{localStorage.getItem("path")}</span>
                  </div>
                </Nav.Link>

                <Nav.Link href="#">
                  <div id="rectangle-37-new-btn">
                    <span align="center">{this.state.date.toLocaleString("id-ID", {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric"

                    })}</span>
                  </div>
                </Nav.Link>

                <Nav.Link href="#">

                  <div id="rectangle-38-new-btn">
                    <span>{this.state.date.toLocaleString("id-ID", {
                      hour: '2-digit',
                      minute: '2-digit'

                    })}</span>
                  </div>
                </Nav.Link>
                
                {/*
                <Nav.Link href="#">
                  <div id="rectangle-38-new-btn">
                    Log
                  </div>
                </Nav.Link>
                */}
                
              </Nav>
            </Navbar.Collapse>

            <Navbar.Collapse
              id="basic-navbar-nav2"
              className="justify-content-end"
            >
              <Nav className="ml-auto">


                {/* <NavDropdown
                  // alignRight
                  align="end"
                  title={
                    <a href="#" style={{ fontSize: 10 }}>
                      <img src={messageIcon} alt="" style={{ width: 25 }} />
                      <span className="notify-badge">{this.state.countNotReadAdd}</span>
                    </a>
                  }
                >
                  <Dropdown.Menu as={CustomMenuAdd}>

                    <div className="menu-header-content bg-primary-gradient d-flex justify-content-between">
                      <div className>
                        <h6 className="menu-header-title text-white mb-0 notification-new_add">{this.state.countNotReadAdd} new My Reports</h6>
                      </div>
                      <div className="my-auto ml-auto" style={{ float: 'right' }}>
                        <Badge bg="warning" text="dark" onclick="read_all_notif()">
                          Mark All Read
                        </Badge>
                      </div>
                    </div>

                    <div className="main-message-list Notification-scroll" style={{ maxHeight: '320px', overflow: 'scroll' }} id="notif_cont_add">


                    </div>

                    <div className="d-grid">
                      <Button variant="primary" size="lg">
                        VIEW ALL
                      </Button>
                    </div>


                  </Dropdown.Menu>
                </NavDropdown> */}


                <NavDropdown
                  // alignRight
                  align="end"
                  title={
                    <a href="#" style={{ fontSize: 10 }}>
                      <img src={notificationIcon} alt="" style={{ width: 20 }} />
                      <span className="notify-badge">{this.state.countNotRead}</span>
                    </a>
                  }

                >
                  <Dropdown.Menu as={CustomMenuAdd}>

                    {/* <div className="menu-header-content bg-primary-gradient d-flex justify-content-between">
                      <div className>
                        <h6 className="menu-header-title text-white mb-0 notification-new_add">{this.state.countNotReadDoc} new My Reports</h6>
                      </div>
                      <div className="my-auto ml-auto" style={{ float: 'right' }}>
                        <Badge bg="warning" text="dark" onclick="read_all_notif()">
                          Mark All Read
                        </Badge>
                      </div>
                    </div> */}

                    <div className="main-message-list Notification-scroll" style={{ maxHeight: '320px', overflowY: 'scroll', overflowX: 'hidden', width: 480 }} id="notif_cont_add">


                      <div className="notifications">


                        {this.state.listNotif.map((item, index) => (

                          // <div className="card"
                          // // onClick={() => this.viewDetailNotifAdd(item)}
                          // >
                          //   <div className="d-flex flex-row comment-row" style={{ width: "400px" }}>
                          //     <div className="p-2"><span className="round">
                          //       {/* <img src={misAPI + "/uploads/avatar/" + item.photo_profile} alt="user" width={50} /> */}
                          //       <img src={uAPIlocal + '/images/logo.png'} alt="user" width={50} />
                          //     </span>
                          //     </div>
                          //     <div className="comment-text w-100">
                          //       <p style={{ marginBottom: 0, fontWeight: 'bold', fontSize: '12px', }}>{item.creator_name}
                          //         <span className="date" style={{ float: 'right', fontSize: '10px' }}>{moment(moment.utc(item.time)).local().format("DD MMMM YYYY hh:mm")}</span>
                          //       </p>
                          //       <p >{item.description}</p>
                          //     </div>
                          //   </div>
                          // </div>


                          <div className="notifications__item">
                            <div className="notifications__item__avatar">
                              <img src={logo} alt="user" width={50} />
                            </div>
                            <div className="notifications__item__content">
                              <span className="notifications__item__title">{item.creator_name}</span>
                              <span className="notifications__item__message">
                                {item.description}
                              </span>
                              <span className="date" style={{ float: 'right', fontSize: '12px', fontWeight: 'bold' }}>{moment(moment.utc(item.time)).local().format("DD MMMM YYYY hh:mm")}</span>
                            </div>
                            <div>
                              <div>
                                <a title="read"
                                  onClick={() => this.readNotif(item.id)}
                                  className="btn btn-success btn-sm"
                                  style={{ textDecoration: 'none', borderRadius: '35px', backgroundImage: "url(" + read + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}>
                                </a>
                              </div>
                              {/* <div className="notifications__item__option delete js-option">
                                <i className="fa fa-trash" />
                              </div> */}
                            </div>
                          </div>



                        ))}


                      </div>
                    </div>
                    {/* 
                    <div className="d-grid">
                      <Button variant="primary" size="lg">
                        VIEW ALL
                      </Button>
                    </div> */}


                  </Dropdown.Menu>
                </NavDropdown>

                <NavDropdown
                  // alignRight
                  align="end"
                  title={
                    <>
                      <div style={{ display: 'flex' }}>
                        <div className="multiLineLabel">
                          <span className="textMaxLine">{localStorage.getItem("name")}</span>
                        </div>
                        <span>
                          <img alt='img1' src={dropdownIcon} />
                        </span>
                      </div>
                    </>
                  }
                >


                  <NavDropdown.Item href="#" onClick={() => this.Logout(0)}>
                    <span className="dropdown-item" href="#">
                      <i className="fa fa-sign-out" /> Log Out
                    </span>
                  </NavDropdown.Item>

                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default Header;
